import reportApi from '@/api/report'

const state = {
  data: null,
  loading: false,

  error: null,
}

const errorText = error => {
  const data = error.response && error.response.data

  return (data && (data.message || data.title)) || 'Не удалось прочитать сводку'
}

const getters = {}

const actions = {
  async fetch({ commit }) {
    if (state.loading) return

    commit('LOADING')
    try {
      const { data } = await reportApi.getDashboard()

      if (data === null || typeof data !== 'object') throw new Error('dashboard is not an object')

      commit('SET_DASHBOARD', data)
    } catch (error) {
      commit('SET_ERROR', errorText(error))
    }
  },
}

const mutations = {
  LOADING(state) {
    state.loading = true
  },
  SET_DASHBOARD(state, data) {
    state.data = data
    state.error = null
    state.loading = false
  },
  SET_ERROR(state, text) {
    state.error = text
    state.loading = false
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
